import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { MenuHighlights } from '../components/MenuHighlights';
import { ReservationForm } from '../components/ReservationForm';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-navy-900 text-white selection:bg-gold-500 selection:text-navy-900" data-id="element-311">
      <Navigation data-id="element-312" />
      <main data-id="element-313">
        <Hero data-id="element-314" />
        <About data-id="element-315" />
        <MenuHighlights data-id="element-316" />
        <ReservationForm data-id="element-317" />
        <Contact data-id="element-318" />
      </main>
      <Footer data-id="element-319" />
    </div>;
}